import { useState, useEffect } from 'react'
import { CART_STORAGE_KEY } from './useCart'
import { loadState } from 'utils/storage'
import { POST } from 'api/request'
import * as urls from 'api/urls'

const useCheckPrice = () => {
  const [data, setData] = useState<undefined | order.CheckPrice>(undefined)
  const [isLoading, setLoading] = useState(false)

  const fetchMagDetails = async (discount_code?: string) => {
    setLoading(true)
    const response = await POST<order.CheckPriceResponse>(urls.checkPrice, { body: { discount_code } })
    if (response.ok) {
      setData({
        discount_code: response.data.discount_code,
        products: response.data.products.reduce((result, element) => {
          result[element.product_id] = element
          return result
        }, {} as order.CheckPriceProductObject)
      })
    } else {
      console.error('An unknown error occurred', 'error')
    }
    setLoading(false)
  }

  useEffect(() => {
    const cart = loadState<order.Cart | undefined>(true, CART_STORAGE_KEY, undefined)
    fetchMagDetails(cart?.discount_code)
  }, [])

  return {
    checkPrice: data,
    isLoading,
    reload: fetchMagDetails
  }
}

export default useCheckPrice